export default {
  list: (state) => state.list,
  modelList: (state) => state.modelList,
  selected: (state) => state.selected,
};
